import { isCustomizedType, reduce } from "et3-type-guards";
import { Ti18nKeys } from "../../constants/i18n";

import i18nServerResponse from "../../constants/i18n-server-response";
import { getDateAsObject } from "../../core/et3-date";
import { TCorePage } from "../../Types";
import { post } from "../axios-post";

export const apiCallGetOtherCSRPerformance = async ({
  adminId,
  dateMin,
  dateMax
}: {
  adminId: number;
  dateMin: Date;
  dateMax: Date;
}): Promise<{
  data: {
    activeTime: number;
    pageName: TCorePage;
    numberOfEvents: number;
    cleanPoolCount: number;
    eventPerHour: number;
  }[];
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<
    {
      activeTime: number;
      pageName: TCorePage;
      numberOfEvents: number;
      cleanPoolCount: number;
      eventPerHour: number;
    }[]
  >(`auditor/getOtherCSRPerformance`, {
    adminId,
    dateMinObject: getDateAsObject(dateMin),
    dateMaxObject: getDateAsObject(dateMax)
  });

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: [],
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: [],
      status: "ERROR",
      code: "ERROR"
    };
  }
};
